<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.update') + $t('attributes.hotel') }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group horizontal name="id" :label="$t('attributes.id')">
              <b-field :type="idStatus">
                <b-input
                  v-model="form.id"
                  :loading="idChecking"
                  name="id"
                  :placeholder="
                    $t('message.please_input') + $t('attributes.id')
                  "
                  expanded
                  :disabled="isEditing"
                  @blur="checkId"
                >
                </b-input>
              </b-field>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="area_code"
              attribute="attributes.area"
              :label="$t('attributes.area')"
            >
              <b-select
                v-model="selectedArea"
                name="area_code"
                :loading="isLoadingArea"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                expanded
                @input="onSelectArea"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.area') }}
                </option>
                <option
                  v-for="option in areas"
                  :key="option.code"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="country_id"
              attribute="attributes.country"
              :label="$t('attributes.country')"
            >
              <b-select
                v-model="selectedCountry"
                name="country_id"
                :loading="isLoadingCountry"
                :placeholder="
                  $t('message.please_select') + $t('attributes.country')
                "
                expanded
                @input="onSelectCountry"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.country') }}
                </option>
                <option
                  v-for="option in countries"
                  :key="option.id"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="region_id"
              attribute="attributes.region"
              :label="$t('attributes.region')"
            >
              <b-select
                v-model="selectedRegion"
                name="region_id"
                :loading="isLoadingRegion"
                :placeholder="
                  $t('message.please_select') + $t('attributes.region')
                "
                expanded
                @input="onSelectRegion"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.region') }}
                </option>
                <option
                  v-for="option in regions"
                  :key="option.id"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="city_id"
              attribute="attributes.city"
              :label="$t('attributes.city')"
            >
              <b-select
                v-model="selectedCity"
                name="city_id"
                :loading="isLoadingCity"
                :placeholder="
                  $t('message.please_select') + $t('attributes.city')
                "
                expanded
                @input="onSelectCity"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.city') }}
                </option>
                <option
                  v-for="option in cities"
                  :key="option.id"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="url"
              attribute="attributes.web_site"
              :label="$t('attributes.web_site')"
            >
              <b-input
                v-model="form.url"
                name="url"
                :placeholder="
                  $t('message.please_input') + $t('attributes.web_site')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="contact_tel"
              attribute="attributes.tel"
              :label="$t('attributes.tel')"
            >
              <b-input
                v-model="form.contact_tel"
                name="contact_tel"
                :placeholder="$t('message.please_input') + $t('attributes.tel')"
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="fax"
              attribute="attributes.fax"
              :label="$t('attributes.fax')"
            >
              <b-input
                v-model="form.fax"
                name="fax"
                :placeholder="$t('message.please_input') + $t('attributes.fax')"
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="address"
              attribute="attributes.address"
              :label="$t('attributes.address')"
            >
              <b-input
                v-model="form.address"
                name="address"
                :placeholder="
                  $t('message.please_input') + $t('attributes.address')
                "
                expanded
              >
              </b-input>
            </form-group>

            <form-group
              horizontal
              name="description"
              attribute="attributes.description"
              :label="$t('attributes.description')"
            >
              <b-input
                v-model="form.description"
                name="description"
                type="textarea"
                maxlength="500"
                :placeholder="
                  $t('message.please_input') + $t('attributes.description')
                "
                expanded
              >
              </b-input>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button :loading="isSending" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="isSending || isLoading"
            type="is-primary"
            native-type="submit"
          >
            {{ this.hotel.id ? $t('attributes.update') : $t('attributes.add') }}
          </b-button>
        </footer>

        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { maxLength, required } from 'vuelidate/lib/validators'
import { AREA_API, COUNTRIES_API, HOTELS_API, REGIONS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'HotelForm',

  props: {
    isSending: {
      type: Boolean,
      default: false
    },
    hotel: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoadingArea: false,
      areas: [],
      selectedArea: null,
      idStatus: '',
      idChecking: false,
      isEditing: this.hotel.id != null,
      title: '',

      isLoadingCountry: false,
      countries: [],
      selectedCountry: null,

      isLoadingRegion: false,
      regions: [],
      selectedRegion: null,

      isLoadingCity: false,
      cities: [],
      selectedCity: null,

      form: {
        id: this.hotel.id,
        area_code: this.hotel.area_code && this.hotel.area_code.trim(),
        country_id: this.hotel.country_id,
        region_id: this.hotel.region_id,
        city_id: this.hotel.city_id,
        name: this.hotel.name && this.hotel.name.trim(),
        url: this.hotel.url && this.hotel.url.trim(),
        contact_tel: this.hotel.contact_tel && this.hotel.contact_tel.trim(),
        fax: this.hotel.fax && this.hotel.fax.trim(),
        address: this.hotel.address && this.hotel.address.trim(),
        description: this.hotel.description && this.hotel.description.trim()
      }
    }
  },
  computed: {
    formTitle() {
      let title = this.id
        ? this.$t('attributes.modify')
        : this.$t('attributes.add')

      title += this.$t('attributes.hotel')

      return title
    },
    isLoading() {
      return (
        this.isLoadingArea ||
        this.isLoadingCountry ||
        this.isLoadingRegion ||
        this.isLoadingCity
      )
    }
  },
  validations: {
    form: {
      id: { required, maxLength: maxLength(20) },
      area_code: { required },
      country_id: { required },
      region_id: { required },
      city_id: { required },
      name: { required, maxLength: maxLength(100) },
      url: { maxLength: maxLength(500) },
      contact_tel: { maxLength: maxLength(20) },
      fax: { maxLength: maxLength(16) },
      address: { maxLength: maxLength(200) },
      description: { maxLength: maxLength(500) }
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.isLoadingArea = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)

        if (this.form.area_code) {
          this.selectedArea = this.areas.find(
            a => a.code === this.form.area_code
          )
          this.form.area_code = this.selectedArea.code
        }

        if (this.selectedArea) {
          await this.loadCountries()
        }
      } catch (e) {
        this.areas = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.isLoadingArea = false
      }
    },
    async loadCountries() {
      try {
        const api = `${AREA_API}/${this.form.area_code}/countries`

        this.isLoadingCountry = true
        const res = await this.axios.get(api)
        this.countries = res.data.data

        if (this.form.country_id) {
          this.selectedCountry = this.countries.find(
            a => a.id === this.form.country_id
          )
          this.form.country_id = this.selectedCountry && this.selectedCountry.id
        }

        if (this.selectedCountry) {
          await this.loadRegions()
        }
      } catch (e) {
        this.countries = []
        this.selectedCountry = null

        notifyService.fetch_error('country', e)
      } finally {
        this.isLoadingCountry = false
      }
    },
    async loadRegions() {
      try {
        const api = `${COUNTRIES_API}/${this.form.country_id}/regions`

        this.isLoadingRegion = true
        const res = await this.axios.get(api)
        this.regions = res.data.data

        if (this.form.region_id) {
          this.selectedRegion = this.regions.find(
            a => a.id === this.form.region_id
          )
          this.form.region_id = this.selectedRegion && this.selectedRegion.id
        }

        if (this.selectedRegion) {
          await this.loadCities()
        }
      } catch (e) {
        this.regions = []
        this.selectedRegion = null

        notifyService.fetch_error('region', e)
      } finally {
        this.isLoadingRegion = false
      }
    },
    async loadCities() {
      try {
        const api = `${REGIONS_API}/${this.form.region_id}/cities`

        this.isLoadingCity = true
        const res = await this.axios.get(api)
        this.cities = res.data.data

        if (this.form.city_id) {
          this.selectedCity = this.cities.find(a => a.id === this.form.city_id)
          this.form.city_id = this.selectedCity && this.selectedCity.id
        }
      } catch (e) {
        this.cities = []
        this.selectedCity = null

        notifyService.fetch_error('region', e)
      } finally {
        this.isLoadingCity = false
      }
    },
    async checkId() {
      if (!this.isEditing && this.form.id === null) {
        this.idStatus = ''
        return
      } else if (this.form.id === '') {
        this.idStatus = ''
        return
      }
      try {
        const api = `${HOTELS_API}/${this.form.id}/check`

        this.idChecking = true
        const res = await this.axios.get(api)
        const result = res.data.data
        if (result) {
          this.idStatus = 'is-success'
        } else {
          this.idStatus = 'is-danger'
        }
      } catch (e) {
        this.idStatus = ''
      } finally {
        this.idChecking = false
      }
    },
    onSelectArea(option) {
      this.form.area_code = option && option.code

      this.selectedCountry = null
      this.form.country_id = null

      this.selectedRegion = null
      this.form.region_id = null

      this.selectedCity = null
      this.form.city_id = null

      this.loadCountries()
    },
    onSelectCountry(option) {
      this.form.country_id = option && option.id

      this.selectedRegion = null
      this.form.region_id = null

      this.selectedCity = null
      this.form.city_id = null

      this.loadRegions()
    },
    onSelectRegion(option) {
      this.form.region_id = option && option.id

      this.selectedCity = null
      this.form.city_id = null

      this.loadCities()
    },
    onSelectCity(option) {
      this.form.city_id = option && option.id
    },

    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }
      if (!this.isEditing && this.idStatus === 'is-danger') {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
